import * as React from "react";
import { forwardRef } from "react";
const SvgComboSearch = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0.998 0.492 16.043 16.043", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#9EA1AC", d: "m16.736 14.816-4.822-4.822a6.018 6.018 0 1 0-1.414 1.414l4.822 4.822a1.001 1.001 0 0 0 1.72-.703 1 1 0 0 0-.306-.71m-9.707-4.293a4 4 0 1 1 0-8 4 4 0 0 1 0 8" }));
const ForwardRef = forwardRef(SvgComboSearch);
export { ForwardRef as ReactComponent };
